module.exports = __webpack_public_path__ + "img/evangheliar-1512-big.e92d0ceb.png";